import { render, staticRenderFns } from "./SendPatientInviteTabs.vue?vue&type=template&id=4a8964ab&scoped=true"
import script from "./SendPatientInviteTabs.vue?vue&type=script&lang=js"
export * from "./SendPatientInviteTabs.vue?vue&type=script&lang=js"
import style0 from "./SendPatientInviteTabs.vue?vue&type=style&index=0&id=4a8964ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8964ab",
  null
  
)

export default component.exports